// Нижний таб-бар: База · Лента · Беседы · Телеграм · Поиск (M1.2).
//
// Пять корней и больше ничего: на телефоне это единственная навигация верхнего
// уровня, и её задача — всегда быть под большим пальцем. Отсюда и высота
// элемента 58px, и то, что бар не прячется при прокрутке.
//
// «Телеграм» стоит рядом с «Беседами» намеренно: канал похож на беседу и
// путать их проще всего, поэтому пусть они лежат рядом и различаются подписью,
// а не прячутся друг от друга по разным углам бара.

import { useAppStore } from '../store/appStore'
import { useMobileStore } from './mobileStore'
import { TAB_GLYPH, TAB_LABEL, type MobileTab } from './nav'

const TABS: MobileTab[] = ['base', 'feed', 'chats', 'messengers', 'search']

export default function TabBar() {
  const tab = useMobileStore((s) => s.tab)
  const setTab = useMobileStore((s) => s.setTab)
  // Счётчик непрочитанного — общий с десктопом: там он висит на секции
  // «БАЗА ДАННЫХ», здесь бейджем на «Ленте».
  const unread = useAppStore((s) => s.unread)

  return (
    <nav className="ab-tabbar" aria-label="разделы">
      {TABS.map((key) => {
        const on = tab === key
        // Трёхзначный счётчик распирает бейдж и сдвигает подпись — режем.
        const badge = key === 'feed' && unread > 0 ? (unread > 99 ? '99+' : String(unread)) : null
        return (
          <button
            key={key}
            className={`ab-tab${on ? ' is-on' : ''}`}
            onClick={() => setTab(key)}
            aria-current={on ? 'page' : undefined}
            aria-label={badge ? `${TAB_LABEL[key]}, непрочитанных ${badge}` : undefined}
          >
            <span className="ab-tab__glyph" aria-hidden>
              {TAB_GLYPH[key]}
              {badge ? <span className="ab-tab__badge">{badge}</span> : null}
            </span>
            <span className="ab-tab__label">{TAB_LABEL[key]}</span>
          </button>
        )
      })}
    </nav>
  )
}
